import { useSearchParams } from 'react-router';
import { stateButtons, stateChoiceOf } from '@claims/core';
import { countOf } from './count.js';

/** THE STATE ROW (Neila 2026-10-12; the medrec console's state-breakout shape, 10-13; the rules are core states.ts): toggle buttons at the
 *  start of a list's filter bar, the visible label "State", "All" first, then CA, then every other state by its count, No state last. One
 *  choice at a time; pressing the pressed state goes back to All. The counts come from the page's whole answer (no narrowing), as the other
 *  filter counts do. The choice lives in the page address (?state=CA), so a link reopens it; All is no parameter. */
export function useStateChoice(): [string | null, (k: string | null) => void] {
  const [sp, setSp] = useSearchParams();
  const choice = stateChoiceOf(sp.get('state'));
  const set = (k: string | null) => {
    const n = new URLSearchParams(sp);
    if (k === null) n.delete('state'); else n.set('state', k);
    setSp(n, { replace: true });
  };
  return [choice, set];
}

export function StateSeg({ states, choice, onChoose }: { states: (string | null | undefined)[]; choice: string | null; onChoose: (k: string | null) => void }) {
  const buttons = stateButtons(states, choice);
  if (!buttons.length) return null;
  return (
    <div className="seg seg-state" role="group" aria-label="State">
      <span className="segl" aria-hidden="true">State</span>
      <button type="button" aria-pressed={choice === null} onClick={() => onChoose(null)}>All</button>
      {buttons.map((b) => (
        <button key={b.key} type="button" aria-pressed={choice === b.key} title={b.title} onClick={() => onChoose(choice === b.key ? null : b.key)}>
          {b.label}<span className="fc">{countOf(b.count)}</span>
        </button>
      ))}
    </div>
  );
}
